export type SynapseLocale = 'fa' | 'en';
export type SynapseTheme = 'light' | 'dark';

const LOCALE_COOKIE = 'synapse_locale';
const THEME_COOKIE = 'synapse_theme';

const COOKIE_MAX_AGE = 60 * 60 * 24 * 365;

const isLocalhost = () =>
  window.location.hostname === 'localhost' ||
  window.location.hostname === '127.0.0.1';

const readCookie = (name: string): string | undefined => {
  const prefix = `${encodeURIComponent(name)}=`;

  const cookie = document.cookie
    .split(';')
    .map((item) => item.trim())
    .find((item) => item.startsWith(prefix));

  if (!cookie) {
    return undefined;
  }

  try {
    return decodeURIComponent(cookie.slice(prefix.length));
  } catch {
    return undefined;
  }
};

const writeCookie = (name: string, value: string) => {
  const attributes = [
    `${encodeURIComponent(name)}=${encodeURIComponent(value)}`,
    'Path=/',
    `Max-Age=${COOKIE_MAX_AGE}`,
    'SameSite=Lax',
  ];

  if (!isLocalhost()) {
    attributes.push('Domain=.synapsecloud.ir');
    attributes.push('Secure');
  }

  document.cookie = attributes.join('; ');
};

export const getSynapseLocale = (): SynapseLocale | undefined => {
  const value = readCookie(LOCALE_COOKIE);

  return value === 'fa' || value === 'en' ? value : undefined;
};

export const setSynapseLocale = (locale: SynapseLocale) => {
  writeCookie(LOCALE_COOKIE, locale);
};

export const getSynapseTheme = (): SynapseTheme | undefined => {
  const value = readCookie(THEME_COOKIE);

  return value === 'light' || value === 'dark' ? value : undefined;
};

export const setSynapseTheme = (theme: SynapseTheme) => {
  writeCookie(THEME_COOKIE, theme);
};
